import { Checkbox } from 'primereact/checkbox';

const AIEduCheckbox = (props) => {
    return <Checkbox {...props} />;
};

export default AIEduCheckbox;
